export default {
  hy: "Armenian",
  ru: "Russian",
  en: "English",
  es: "Spanish"
};



// WEBPACK FOOTER //
// ./src/data/languages.js